const NAME = "GEO_QUERY_DEFINITION_PAGE";

export default NAME;
